// src/com/trans_plan/TransPlanDict.js
import { InputType, TableColumnType } from "../../value/AppConst";
import IsValid from "../../value/IsValid";

// 운송요청 배차내역 테이블, trans_plan
const Dict = {
    // toAdd, toEdit : mark if need to submit for mutation
    planId : {
		id: 'planId', label: '배차번호',
		type: InputType.text, required: true, toAdd: false, toEdit: true,
	}, // varchar(12)
    dcCd : {
		id: 'dcCd', label: '출발지',
		type: InputType.select, required: true, toAdd: true, toEdit: false,
        labelKey: 'dcName',
	}, // varchar(3)
    arriveId : {
		id: 'arriveId', label: '운행지코드',
		type: InputType.select, required: true, toAdd: false, toEdit: false, // no need to submit
	}, // varchar(12)
    storeId : {
		id: 'storeId', label: '도착지',
		type: InputType.select, required: true, toAdd: true, toEdit: false,
        labelKey: 'storeName',
	}, // varchar(10)
    comId : {
		id: 'comId', label: '운송사',
		type: InputType.select, required: true, toAdd: true, toEdit: true,
        labelKey: 'comName',
	}, // varchar(10)
    dcStaffName : { id: 'dcStaffName', label: '센터담당자', }, // varchar(18)
    agentStaffName : { id: 'agentStaffName', label: '에이전트담당자', }, // varchar(15)
    cargoStaffName : { id: 'cargoStaffName', label: '화물담당자', }, // varchar(15)
    cargoTel : { id: 'cargoTel', label: '화물담당자 전화번호', }, // varchar(15)
    planDate : {
		id: 'planDate', label: '배차일자',
		type: InputType.date, required: true, toAdd: true, toEdit: false,
	}, // date
    planTime : {
		id: 'planTime', label: '배차시간',
		required: false, toAdd: false, toEdit: false,
	}, // timestamp
    hocha : {
		id: 'hocha', label: '호차',
		type: InputType.number, required: true, toAdd: true, toEdit: false,
		check: (value) => {return value >= 1 && value <= 999},
	}, // int(11)
    transTypeCd : {
		id: 'transTypeCd', label: '배차구분', // WAVE1, WAVE2, WAVE3
		type: InputType.select, required: true, toAdd: true, toEdit: true,
	}, // varchar(10)
    // txStage : { id: 'txStage', label: 'txStage', }, // enum('legacy','init','hold','open','assigned','running','arrived','done','cancel')
    vehTypeId : {
		id: 'vehTypeId', label: '차종',
		type: InputType.select, required: true, toAdd: true, toEdit: true,
		labelKey: 'vehTypeName',
	}, // varchar(10)
    vehTypeName : { id: 'vehTypeName', label: '차종', }, // varchar(50)
    shprReqTime : {
		id: 'shprReqTime', label: '접안시간',
		type: InputType.datetime, required: true, toAdd: true, toEdit: true,
	}, // timestamp
    dptrReqTime : {
		id: 'dptrReqTime', label: '출발요청시간',
		type: InputType.datetime, required: true, toAdd: true, toEdit: true,
	}, // timestamp
    arrReqTime : {
		id: 'arrReqTime', label: '도착요청시간',
		type: InputType.datetime, required: true, toAdd: true, toEdit: true,
	}, // timestamp
    dockno : {
		id: 'dockno', label: 'Dock No.',
		type: InputType.text, required: true, toAdd: true, toEdit: true,
		help: '3자 이내로 입력하세요.',
		check: (value) => {return IsValid.string(value, 0, 3)},
	}, // varchar(3)
    addCharge : {
		id: 'addCharge', label: '추가운임',
		type: InputType.number, required: true, toAdd: true, toEdit: true,
		check: (value) => {return value >= 0 && value <= 1000000},
	}, // int(11)
    note : {
		id: 'note', label: '비고',
		type: InputType.text, required: false, toAdd: true, toEdit: true,
		help: '300자 이내로 입력하세요.',
		check: (value) => {return IsValid.string(value, 0, 300)},
	}, // varchar(300)
    zipgiBool : {
		id: 'zipgiBool', label: '집기',
		type: InputType.checkbox, required: true, toAdd: true, toEdit: true,
	}, // tinyint(1)
    /* charge : { id: 'charge', label: '운임', }, // int(11)
    reqStateFlag : { id: 'reqStateFlag', label: 'Check common_code', }, // '0' 운송요청 등록, '1' TSR 미발행, '2' TSR 발행
    transFlag : { id: 'transFlag', label: '배차(true) 또는 미배차', }, // tinyint(1)
    vehInfoSeq : { id: 'vehInfoSeq', label: 'vehInfoSeq', }, // int(11)
    bol1 : {id: 'bol1', label: 'bol1',}, // varchar(18)
    bol2 : {id: 'bol2', label: 'bol2',}, // varchar(18)
    bol3 : {id: 'bol3', label: 'bol3',}, // varchar(18)
    loadCount : {id: 'loadCount', label: 'loadCount'}, // int(11)
    loadStTime : {id: 'loadStTime', label: 'loadStTime',}, // timestamp
    loadEnTime : {id: 'loadEnTime', label: 'loadEnTime',}, // timestamp
    prosDptrTime : {id: 'prosDptrTime', label: 'prosDptrTime',}, // timestamp
    prosArrTime : {id: 'prosArrTime', label: 'prosArrTime',}, // timestamp
    sealNo1 : {id: 'sealNo1', label: 'Seal번호(1)',}, // varchar(10)
    sealNo2 : { id: 'sealNo2', label: 'sealNo2', }, // varchar(10)
    sealNo3 : { id: 'sealNo3', label: 'sealNo3', }, // varchar(10)
    loadStaffName : { id: 'loadStaffName', label: 'loadStaffName', }, // varchar(15)
    unsoldBol : { id: 'unsoldBol', label: 'unsoldBol', }, // varchar(18)
    unsoldPallet : { id: 'unsoldPallet', label: 'unsoldPallet', }, // int(11)
    unsoldCount : { id: 'unsoldCount', label: 'unsoldCount', }, // int(11)
    memo : { id: 'memo', label: '메모', }, // varchar(400)
    inputArrTime : { id: 'inputArrTime', label: 'inputArrTime', }, // timestamp
    traceStatus : { id: 'traceStatus', label: 'traceStatus', }, // tinyint(1)
    regTypeCd : { id: 'regTypeCd', label: '업로드(A), 수동(M), 요청(R)', }, // enum('R','A','M')
    endFlag : {
		id: 'endFlag', label: 'endFlag',
		type: InputType.text, required: false, toAdd: true, toEdit: true,
		help: '1자 이내로 입력하세요.',
		check: (value) => {return IsValid.string(value, 0, 1)},
	}, // char(1)
    inputDptrTime : { id: 'inputDptrTime', label: 'inputDptrTime', }, // timestamp
    printDate : { id: 'printDate', label: 'printDate', }, // timestamp
    printUser : { id: 'printUser', label: 'printUser', }, // varchar(40)
    inputTempF : { id: 'inputTempF', label: 'inputTempF', }, // varchar(8)
    inputTempM : { id: 'inputTempM', label: 'inputTempM', }, // varchar(8)
    inputTempR : { id: 'inputTempR', label: 'inputTempR', }, // varchar(8)
    // dcTypeCd : { id: 'dcTypeCd', label: 'dcTypeCd', }, // enum('A','F','E')
    dcTypeName : { id: 'dcTypeName', label: 'dcTypeName', }, // varchar(20)
    transPosYn : { id: 'transPosYn', label: '위치추적여부', }, // enum('Y','N')
    distKm : { id: 'distKm', label: '주행거리', }, // double
    direction : { id: 'direction', label: '진행방향. less than 360 degree', }, // int(4)
    //irAction : { id: 'irAction', label: 'Event, 사용 안함', }, // int(3)
    //posSys : { id: 'posSys', label: 'posSys', }, // char(1) */
    vehPlates : { id: 'vehPlates', label: '차량번호', }, // varchar(20)
    driverName : { id: 'driverName', label: '운전자', }, // varchar(64)
    driverMobile : { id: 'driverMobile', label: '전화번호', }, // varchar(64)
    dcName : { id: 'dcName', label: '출발지',}, // varchar(20)
    comName : { id: 'comName', label: '운송사', }, // varchar(30)
    storeName : { id: 'storeName', label: '도착지', }, // varchar(30)
    gpsTime : { id: 'gpsTime', label: '최종추적일시', }, // timestamp
    location : { id: 'location', label: '최종위치', }, // varchar(300)
    speed : { id: 'speed', label: '속도', }, // double
    tempr1 : { id: 'tempr1', label: '전면', }, // double
    tempr2 : { id: 'tempr2', label: '후면', }, // double
    tempr3 : { id: 'tempr3', label: '중면', }, // double
    
};

function printMdHm(r, i, v) {
    return v?v.substring(5,16).replace('-','/'):'-';
}

function printTemp(r, i, v) {
    if(v) {
        if(v < -100) return null;
        return v;
    }
    return null;
}

/**
 * TRANS_PLAN React Component Dictionary for Input and Output
 * Project: NewTOP for cloud
 * 2024-11-27 14:19:42 using DbdbTap
 * https://www.dbdbtap.com
 */
export const TransPlanDictionary = {
    inputMap: Dict,
    errorTitle: {
        Add: '배차 등록 오류',
        Edit: '배차 수정 오류',
        Remove: '배차 삭제 오류',
        Get: '관제목록 조회 오류',
    },
    tableProps: {
        tableId: 'transPlanTable',
        uniqueKey: 'vehInfoSeq',
        flexOption: {
            multiChecker:false,
            hideFirstTopButton: false,
            hideColumnConfig: true,
            hideBubble: false,
            growToFill: true,
        },
        columns: [
            { id: 'dcName', label: Dict.dcName.label, width: 85, show: true, option:{align: 'inherit', type:TableColumnType.TEXT} },
            { id: 'storeName', label: Dict.storeName.label, width: 110, show: true, option:{align: 'inherit', type:TableColumnType.TEXT} },
            { id: 'arrReqTime', label: Dict.arrReqTime.label, width: 95, show: true, option:{align: 'center', print:printMdHm} },
            { id: 'hocha', label: Dict.hocha.label, width: 60, show: true, option:{align: 'center', type:TableColumnType.INTEGER} },
            //print using getTableColumnOption(c,t,i)
            { id: 'vehPlates', label: Dict.vehPlates.label, width: 120, show: true, option:{align: 'inherit', type:TableColumnType.TEXT} },
            { id: 'location', label: Dict.location.label, width: 220, show: true, option:{align: 'inherit', type:TableColumnType.TEXT} },
            { id: 'gpsTime', label: Dict.gpsTime.label, width: 130, show: true, option:{align: 'center', print:(r,i,v)=>v?v.substring(0,16):'-'} },
            { id: 'comName', label: Dict.comName.label, width: 150, show: true, option:{align: 'inherit', type:TableColumnType.TEXT} },
            { id: 'driverName', label: Dict.driverName.label, width: 100, show: true, option:{align: 'inherit', type:TableColumnType.TEXT} },
            { id: 'driverMobile', label: Dict.driverMobile.label, width: 120, show: true, privacy:true, option:{align: 'inherit', type:TableColumnType.TEXT} },
            { id: 'speed', label: Dict.speed.label, width: 60, show: true, option:{align: 'right', type:TableColumnType.FLOAT} },
            { id: 'tempr1', label: Dict.tempr1.label, width: 80, show: true, option:{align: 'right', print: printTemp} },
            { id: 'tempr3', label: Dict.tempr3.label, width: 80, show: true, option:{align: 'right', print: printTemp} },
            { id: 'tempr2', label: Dict.tempr2.label, width: 80, show: true, option:{align: 'right', print: printTemp} },
            // { id: 'planId', label: Dict.planId.label, width: 120, show: true, option:{align: 'inherit', type:TableColumnType.TEXT} },
            /* 
            { id: 'dcCd', label: Dict.dcCd.label, width: 120, show: true, option:{align: 'inherit', type:TableColumnType.TEXT} },
            { id: 'arriveId', label: Dict.arriveId.label, width: 120, show: true, option:{align: 'inherit', type:TableColumnType.TEXT} },
            { id: 'storeId', label: Dict.storeId.label, width: 120, show: true, option:{align: 'inherit', type:TableColumnType.TEXT} },
            { id: 'comId', label: Dict.comId.label, width: 120, show: true, option:{align: 'inherit', type:TableColumnType.TEXT} },
            { id: 'dcStaffName', label: Dict.dcStaffName.label, width: 120, show: true, option:{align: 'inherit', type:TableColumnType.TEXT} },
            { id: 'agentStaffName', label: Dict.agentStaffName.label, width: 120, show: true, option:{align: 'inherit', type:TableColumnType.TEXT} },
            { id: 'cargoStaffName', label: Dict.cargoStaffName.label, width: 120, show: true, option:{align: 'inherit', type:TableColumnType.TEXT} },
            { id: 'cargoTel', label: Dict.cargoTel.label, width: 120, show: true, option:{align: 'inherit', type:TableColumnType.TEXT} },
            { id: 'planDate', label: Dict.planDate.label, width: 120, show: true, option:{align: 'inherit', type:TableColumnType.TEXT} },
            { id: 'planTime', label: Dict.planTime.label, width: 120, show: true, option:{align: 'inherit', type:TableColumnType.DATETIME} },
            { id: 'transTypeCd', label: Dict.transTypeCd.label, width: 120, show: true, option:{align: 'inherit', type:TableColumnType.TEXT} },
            { id: 'txStage', label: Dict.txStage.label, width: 120, show: true, option:{align: 'inherit', type:TableColumnType.TEXT} },
            { id: 'vehTypeId', label: Dict.vehTypeId.label, width: 120, show: true, option:{align: 'inherit', type:TableColumnType.TEXT} },
            { id: 'vehTypeName', label: Dict.vehTypeName.label, width: 120, show: true, option:{align: 'inherit', type:TableColumnType.TEXT} },
            { id: 'shprReqTime', label: Dict.shprReqTime.label, width: 120, show: true, option:{align: 'inherit', type:TableColumnType.DATETIME} },
            { id: 'dptrReqTime', label: Dict.dptrReqTime.label, width: 120, show: true, option:{align: 'inherit', type:TableColumnType.DATETIME} },
            { id: 'dockno', label: Dict.dockno.label, width: 120, show: true, option:{align: 'inherit', type:TableColumnType.TEXT} },
            { id: 'charge', label: Dict.charge.label, width: 120, show: true, option:{align: 'right', type:TableColumnType.INTEGER} },
            { id: 'addCharge', label: Dict.addCharge.label, width: 120, show: true, option:{align: 'right', type:TableColumnType.INTEGER} },
            { id: 'note', label: Dict.note.label, width: 120, show: true, option:{align: 'inherit', type:TableColumnType.TEXT} },
            { id: 'reqStateFlag', label: Dict.reqStateFlag.label, width: 120, show: true, option:{align: 'inherit', type:TableColumnType.TEXT} },
            { id: 'transFlag', label: Dict.transFlag.label, width: 120, show: true, option:{align: 'center', type:TableColumnType.BOOLEAN} },
            { id: 'vehInfoSeq', label: Dict.vehInfoSeq.label, width: 120, show: true, option:{align: 'right', type:TableColumnType.INTEGER} },
            { id: 'bol1', label: Dict.bol1.label, width: 120, show: true, option:{align: 'inherit', type:TableColumnType.TEXT} },
            { id: 'bol2', label: Dict.bol2.label, width: 120, show: true, option:{align: 'inherit', type:TableColumnType.TEXT} },
            { id: 'bol3', label: Dict.bol3.label, width: 120, show: true, option:{align: 'inherit', type:TableColumnType.TEXT} },
            { id: 'loadCount', label: Dict.loadCount.label, width: 120, show: true, option:{align: 'right', type:TableColumnType.INTEGER} },
            { id: 'loadStTime', label: Dict.loadStTime.label, width: 120, show: true, option:{align: 'inherit', type:TableColumnType.DATETIME} },
            { id: 'loadEnTime', label: Dict.loadEnTime.label, width: 120, show: true, option:{align: 'inherit', type:TableColumnType.DATETIME} },
            { id: 'prosDptrTime', label: Dict.prosDptrTime.label, width: 120, show: true, option:{align: 'inherit', type:TableColumnType.DATETIME} },
            { id: 'prosArrTime', label: Dict.prosArrTime.label, width: 120, show: true, option:{align: 'inherit', type:TableColumnType.DATETIME} },
            { id: 'sealNo1', label: Dict.sealNo1.label, width: 120, show: true, option:{align: 'inherit', type:TableColumnType.TEXT} },
            { id: 'sealNo2', label: Dict.sealNo2.label, width: 120, show: true, option:{align: 'inherit', type:TableColumnType.TEXT} },
            { id: 'sealNo3', label: Dict.sealNo3.label, width: 120, show: true, option:{align: 'inherit', type:TableColumnType.TEXT} },
            { id: 'loadStaffName', label: Dict.loadStaffName.label, width: 120, show: true, option:{align: 'inherit', type:TableColumnType.TEXT} },
            { id: 'unsoldBol', label: Dict.unsoldBol.label, width: 120, show: true, option:{align: 'inherit', type:TableColumnType.TEXT} },
            { id: 'unsoldPallet', label: Dict.unsoldPallet.label, width: 120, show: true, option:{align: 'right', type:TableColumnType.INTEGER} },
            { id: 'unsoldCount', label: Dict.unsoldCount.label, width: 120, show: true, option:{align: 'right', type:TableColumnType.INTEGER} },
            { id: 'memo', label: Dict.memo.label, width: 120, show: true, option:{align: 'inherit', type:TableColumnType.TEXT} },
            { id: 'inputArrTime', label: Dict.inputArrTime.label, width: 120, show: true, option:{align: 'inherit', type:TableColumnType.DATETIME} },
            { id: 'traceStatus', label: Dict.traceStatus.label, width: 120, show: true, option:{align: 'center', type:TableColumnType.BOOLEAN} },
            { id: 'regTypeCd', label: Dict.regTypeCd.label, width: 120, show: true, option:{align: 'inherit', type:TableColumnType.TEXT} },
            { id: 'endFlag', label: Dict.endFlag.label, width: 120, show: true, option:{align: 'inherit', type:TableColumnType.TEXT} },
            { id: 'zipgiBool', label: Dict.zipgiBool.label, width: 120, show: true, option:{align: 'center', type:TableColumnType.BOOLEAN} },
            { id: 'inputDptrTime', label: Dict.inputDptrTime.label, width: 120, show: true, option:{align: 'inherit', type:TableColumnType.DATETIME} },
            { id: 'printDate', label: Dict.printDate.label, width: 120, show: true, option:{align: 'inherit', type:TableColumnType.DATETIME} },
            { id: 'printUser', label: Dict.printUser.label, width: 120, show: true, option:{align: 'inherit', type:TableColumnType.TEXT} },
            { id: 'inputTempF', label: Dict.inputTempF.label, width: 120, show: true, option:{align: 'inherit', type:TableColumnType.TEXT} },
            { id: 'inputTempM', label: Dict.inputTempM.label, width: 120, show: true, option:{align: 'inherit', type:TableColumnType.TEXT} },
            { id: 'inputTempR', label: Dict.inputTempR.label, width: 120, show: true, option:{align: 'inherit', type:TableColumnType.TEXT} },
            { id: 'regDate', label: "regDate", width: 120, show: true, option:{align: 'inherit', type:TableColumnType.DATETIME} },
            { id: 'regUser', label: "regUser", width: 120, show: true, option:{align: 'inherit', type:TableColumnType.TEXT} },
            { id: 'dcTypeCd', label: Dict.dcTypeCd.label, width: 120, show: true, option:{align: 'inherit', type:TableColumnType.TEXT} },
            { id: 'dcTypeName', label: Dict.dcTypeName.label, width: 120, show: true, option:{align: 'inherit', type:TableColumnType.TEXT} },
            { id: 'transPosYn', label: Dict.transPosYn.label, width: 120, show: true, option:{align: 'inherit', type:TableColumnType.TEXT} },
            { id: 'distKm', label: Dict.distKm.label, width: 120, show: true, option:{align: 'right', type:TableColumnType.FLOAT} },
            { id: 'direction', label: Dict.direction.label, width: 120, show: true, option:{align: 'right', type:TableColumnType.INTEGER} },
            { id: 'irAction', label: Dict.irAction.label, width: 120, show: true, option:{align: 'right', type:TableColumnType.INTEGER} },
            { id: 'posSys', label: Dict.posSys.label, width: 120, show: true, option:{align: 'inherit', type:TableColumnType.TEXT} },
            */
        ]
    },
};
